import { Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import { ICallAPIFunction } from "../../yoello-lib/modules/API2/types";
import { TaxesFormDialog } from "./TaxesFormDialog";
import { TaxesList } from "./ui/TaxesList";
import Styles from '../../scss/taxes.module.scss';
import { OrderListHeaders } from "../orders/OrderList/OrderListViewHeaders";
import { taxColumns } from "./columns";
import { ITax } from "../../yoello-lib/modules/interfaces/ITaxes";
import { useStyles } from "../menu/products/categories/CategoriesListController";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { DialogRoute } from "../dialogRoutes/DialogRoute";
import { TaxesFeeItems } from "./TaxesFees";
import { TaxesMenuItems } from "./TaxesMenuItems";
import { APPLY_TO_FEES, APPLY_TO_ITEMS, BY_ID, CREATE_URL } from "../../const/URL.const";
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../const/permissions.const";
import DisabledActionWrapper from "../../yoello-lib/modules/components/DisabledActionWrapper";

interface ITaxesItemContainer {
    taxesList: any[];
    isLoading: boolean;
    callTaxesAPI?: ICallAPIFunction<any>;
    venueId: string;
    isVenueOpen: boolean;
}


export function TaxesItemContainer({
    taxesList,
    isLoading,
    callTaxesAPI,
    venueId,
    isVenueOpen
}: ITaxesItemContainer) {
    const { t } = useTranslation();
    const classes = useStyles();
    let { path } = useRouteMatch();
    const history = useHistory();

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

    function onClick() {
        history.push(`${path}/${CREATE_URL}`, {
        });
    }
    function editItem(item: ITax) {
        if (isVenueOpen) {
            return;
        }
        history.push(`${path}/${item.id}`, {
            formData: item,
            isVenueOpen
        });
    }
    return <Switch>
        <Route path={path}>
            <div className={classes.controls}>
                <div className={Styles.create}>
                    <DisabledActionWrapper
                     disabled={!hasPermission}
                     onDisabledClick={onFailedInteraction}
                    >
                        <Button onClick={onClick}
                            size="large"
                            variant="contained"
                            color="primary"
                            data-component-name="CREATE_NEW_TAX"
                            startIcon={<Add />}
                            disabled={!hasPermission || isLoading}
                        >
                            {t('taxes.taxContainer.create')}

                        </Button>
                    </DisabledActionWrapper>    
                </div>

            </div>
            <div data-component-name="TaxesListContainer">
                <div key={`columnHeaders-taxItems`} className={Styles.columnsHeader}>
                    {taxColumns.map((column) => <OrderListHeaders {...column} key={`col-${column.key}-${column.label}`} />)}
                </div>
                <TaxesList
                    isLoading={isLoading}
                    itemList={taxesList}
                    columns={taxColumns}
                    itemSize={70}
                    onItemSelection={editItem}
                    emptyListTitle={t('taxes.taxContainer.emptyList')}
                    emptyListInfo={t('taxes.taxContainer.emptyListInfo')}
                    className={Styles.taxItem}
                    isVenueOpen={isVenueOpen}
                />
            </div>
            <Route exact path={`${path}${BY_ID}`}>
                <DialogRoute Component={(props: any) =><TaxesFormDialog {...props} hasPermission={hasPermission} onFailedInteraction={onFailedInteraction} />}
                    navigateBackRoute={path}
                    ComponentPropsFunctions={{
                        callTaxesAPI,
                        isVenueOpen
                    }}
                    dialogTitle={t('taxes.taxContainer.dialogTitle')}
                />
            </Route>
            <Route exact path={`${path}${APPLY_TO_ITEMS}${BY_ID}`}>
                <DialogRoute Component={TaxesMenuItems}
                    navigateBackRoute={path}
                    ComponentPropsFunctions={{
                        callTaxesAPI,
                        isVenueOpen
                    }}
                    dialogTitle={t('taxes.dialog.title')}
                />
            </Route>
            <Route exact path={`${path}${APPLY_TO_FEES}${BY_ID}`}>
                <DialogRoute Component={TaxesFeeItems}
                    navigateBackRoute={path}
                    ComponentPropsFunctions={{
                        callTaxesAPI,
                        isVenueOpen
                    }}
                    dialogTitle={t('taxes.dialog.titleFee')}
                />
            </Route>
        </Route>
    </Switch>;
}
